<template>
  <CockpitDialog
    title="应急响应"
    left="630px"
    width="890px"
    height="650px"
    top="120px"
    @close="$emit('close')"
  >
    <div class="h-full flex flex-col">
      <el-form ref="form" label-width="120px" :model="formData" v-loading="loading">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              label="启用应急预案"
              prop="enablePlanId"
              :rules="[
                {
                  required: true,
                  message: '请输入启用应急预案',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <preplan-select v-model="formData.enablePlanId"></preplan-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="响应等级"
              prop="responseLevel"
              :rules="[
                {
                  required: true,
                  message: '请输入响应等级',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                popper-class="visualization-select-popper"
                v-model="formData.responseLevel"
                size="small"
                placeholder="请选择响应等级"
                clearable
              >
                <el-option
                  v-for="item in responseLevelList"
                  :key="item.value"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="处置人"
              prop="disposalUsers"
              :rules="[
                {
                  required: true,
                  message: '请输入处置人',
                  trigger: ['blur'],
                },
              ]"
            >
              <CockpitPersonSelect v-model="formData.disposalUsers"></CockpitPersonSelect>
              <!-- <MultiplePersonSelect
                v-model="formData.disposalUsers"
                placeholder="请选择处置人"
              ></MultiplePersonSelect> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="应急疏散"
              prop="isOpenEvacuate"
              :rules="[
                {
                  required: true,
                  message: '请输入应急疏散',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <!-- inactive-color="#ff4949" -->
              <el-switch
                v-model="formData.isOpenEvacuate"
                active-color="#13ce66"
                inactive-color="#2ce1d9"
              ></el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="formData.isOpenEvacuate">
            <el-form-item
              label="疏散目标位置"
              prop="evacuateSafetyIslandIds"
              :rules="[
                {
                  required: true,
                  message: '请输入疏散目标位置',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                class="w-full"
                popper-class="visualization-select-popper"
                v-model="formData.evacuateSafetyIslandIds"
                size="small"
                placeholder="请选择疏散目标位置"
                clearable
              >
                <el-option
                  v-for="item in pathTargetList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="flex-auto h-0">
        <!-- <el-tabs v-model="activeName" v-loading="loading">
          <el-tab-pane label="应急物资" name="emergencyMaterialTable">
            <EmergencyMaterialTable ref="emergencyMaterialTable"></EmergencyMaterialTable>
          </el-tab-pane>
          <el-tab-pane label="救援调度" name="rescueSchedulingTable">
            <RescueSchedulingTable ref="rescueSchedulingTable"></RescueSchedulingTable>
          </el-tab-pane>
          <el-tab-pane label="疏散路径" name="evacuationPathTable" v-if="formData.isOpenEvacuate">
            <EvacuationPathTable ref="evacuationPathTable"></EvacuationPathTable>
          </el-tab-pane>
        </el-tabs> -->
        <div class="flex items-center">
          <tableButtonGroup
            v-model="activeTab"
            :list="formData.isOpenEvacuate ? tabList : tabList.slice(0, 2)"
          />
          <button class="handle_btn !bg-[#CFC929] mr-10px ml-10px" type="button" @click="handleAdd">
            {{ activeTab | toText }}
          </button>
        </div>
        <EmergencyMaterialTable
          v-show="activeTab === '应急物资'"
          ref="emergencyMaterialTable"
        ></EmergencyMaterialTable>
        <RescueSchedulingTable
          v-show="activeTab === '救援调度'"
          ref="rescueSchedulingTable"
        ></RescueSchedulingTable>
        <EvacuationPathTable
          v-if="formData.isOpenEvacuate"
          v-show="activeTab === '疏散路径'"
          ref="evacuationPathTable"
        ></EvacuationPathTable>
      </div>
      <div class="text-center mt-10px flex justify-center">
        <button
          type="primary"
          size="small"
          @click="handleOk"
          icon="iconfont icon-save"
          :loading="loading"
          class="handle_btn mr-10px"
        >
          <span>确定</span>
        </button>
        <button class="handle_btn" size="small" @click="$emit('close')" icon="iconfont icon-close">
          <span>取消</span>
        </button>
      </div>
    </div>
  </CockpitDialog>
</template>

<script type="text/babel">
import {
  AccidentEventsResponseRecordingApi,
  EvacuateSafetyIslandApi,
} from '@wiz-api/emergency-management'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import CockpitDialog from '@/components/cockpit/CockpitDialog'
// import MultiplePersonSelect from './TableList/MultiplePersonSelect'
// import utils from '@/components/safety/enumField/utils'
import RescueSchedulingTable from './TableList/RescueSchedulingTable'
import EmergencyMaterialTable from './TableList/EmergencyMaterialTable'
import EvacuationPathTable from './TableList/EvacuationPathTable'
import PreplanSelect from './TableList/PreplanSelect'
import CockpitPersonSelect from './TableList/CockpitPersonSelect'
import tableButtonGroup from '../../../../../../components/cockpit/TableButtonGroup'

const accidentEventsResponseRecordingApi = new AccidentEventsResponseRecordingApi()
const evacuateSafetyIslandApi = new EvacuateSafetyIslandApi()
const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()
const dataCategoryApi = new DataCategoryApi()
export default {
  name: 'map-response-dialog',
  components: {
    RescueSchedulingTable,
    EmergencyMaterialTable,
    EvacuationPathTable,
    // MultiplePersonSelect,
    PreplanSelect,
    CockpitDialog,
    CockpitPersonSelect,

    tableButtonGroup,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
  },
  filters: {
    toText(value) {
      if (value === '应急物资') {
        return '添加物资'
      }
      if (value === '救援调度') {
        return '添加人员'
      }
      if (value === '疏散路径') {
        return '添加'
      }
      return ''
    },
  },
  data() {
    return {
      tabList: ['应急物资', '救援调度', '疏散路径'],
      activeTab: '应急物资',
      loading: false,
      responseLevelList: [],
      pathTargetList: [],
      formData: {
        enablePlanId: '',
        hiddenDangerlevel: '',
        isOpenEvacuate: false,
        disposalUsers: '',
      },
      activeName: 'emergencyMaterialTable',
      visible: true,
      hiddenLevelList: [],
    }
  },
  computed: {},
  watch: {
    'formData.isOpenEvacuate': {
      handler(val) {
        if (!val && this.activeTab === '疏散路径') {
          this.activeTab = '应急物资'
        }
      },
    },
    activeName(value) {
      this.$nextTick(() => {
        this.$refs[value].$refs.table.doLayout()
      })
    },
    visible(val) {
      if (!val) {
        this.$emit('close')
      }
    },
  },
  created() {
    this.getDataCategory(
      ['EmergencyManagement.DataCategory.ResponseLevel'],
      ['responseLevelList'],
      this
    )
    this.getPathTargetList()
  },
  mounted() {},
  methods: {
    handleAdd() {
      if (this.activeTab === '应急物资') {
        this.$refs.emergencyMaterialTable.formDialog = true
      }
      if (this.activeTab === '救援调度') {
        this.$refs.rescueSchedulingTable.formDialog = true
      }
      if (this.activeTab === '疏散路径') {
        this.$refs.evacuationPathTable.formDialog = true
      }
    },
    clearName() {
      this.$emit('update:id', '')
      this.$emit('update:name', '')
    },
    handleOk() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const emergencyMaterialTable = this.$refs.emergencyMaterialTable.tableData
          const rescueSchedulingTable = this.$refs.rescueSchedulingTable.tableData
          // const regionalPersonnelTable = this.$refs.regionalPersonnelTable.tableData
          const evacuationPathTable = this.$refs.evacuationPathTable
            ? this.$refs.evacuationPathTable.tableData
            : []
          this.loading = true
          const [err, res] = await accidentEventsResponseRecordingApi.saveResponse({
            body: {
              ...this.formData,
              id: this.FormData.accidentId,
              goods: emergencyMaterialTable,
              rescueDispatchs: rescueSchedulingTable,
              paths: evacuationPathTable,
            },
          })
          if (!err) {
            this.$message.success('响应成功')
            this.$emit('handleOk')
            this.visible = false
          }
          this.loading = false
        }
      })
    },
    // 获取疏散路径目标位置
    async getPathTargetList() {
      const [err, res] = await evacuateSafetyIslandApi.getDropDownList()
      if (!err) {
        this.pathTargetList = res || []
      }
    },
    async getDataCategory(codeList = [], values = [], vue) {
      const [configError, abpConfigList] = await abpApplicationConfigurationApi.get()
      if (!configError) {
        const codes = []
        codeList.forEach((item) => {
          codes.push(abpConfigList.setting.values[item])
        })
        const [statusError, statusRes] = await dataCategoryApi.getListByCodes({
          codes,
          includeDetails: true,
        })
        const codeMap = codes.reduce((pre, code, index) => {
          pre[code] = values[index]
          return pre
        }, {})
        if (!statusError) {
          const [err, res] = await dataCategoryApi.getListByIds({
            ids: statusRes.map((item) => {
              return item.id
            }),
            includeDetails: true,
          })
          if (!err) {
            res.forEach((item) => {
              vue[codeMap[item.code]] = item.dataItems.map((i) => {
                return {
                  value: i.code,
                  label: i.displayName,
                  ...i,
                }
              })
            })
          }
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #4dc2d2;
  }
}
.handle_btn[disabled] {
  cursor: no-drop;
}
::v-deep .el-tabs {
  height: 100%;

  .el-tabs__content {
    height: calc(100% - 55px);

    .el-tab-pane {
      overflow-y: auto;
      height: 100%;
    }
  }
}
</style>
